import FeatureController from '../FeatureController';

export default class EditController extends FeatureController {

    constructor (panel, $state) {
      super(panel, $state);
      console.log($state);
      this.profile = {};
      this.register = {};
      this.match = {};
      this.age_range = this.panel.range(17, 100);
      const self = this;
      let username = this.panel.getUser().screen_name;
      this.panel.get('/v1/profile/' + username, (response) => {
          if (self.panel.okay(response)) {
              for (let i in response) {
                  if (i !== 'data') {
                      self[i] = response[i];
                  } else {
                      for (let j in response.data) {
                          self[j] = response.data[j];
                      }
                  }
              }
          }
      });
    }

    redirectUrl (url) {
        history.pushState(null, null, url);
    }

    update_profile (redirectUrl) {
        redirectUrl = redirectUrl ? redirectUrl : '/profile/'+this.panel.getUser().screen_name;
        let birthday = $("#birthday").val();

        if (birthday !== '') {
            let year = new Date().getFullYear();
            let birth_year = parseInt(birthday.substring(0,4));

            if (year - birth_year < 17) {
                this.panel.alert("Invalid age. You must be at least +17 years old.");
                return;
            }
            this.profile.birthday = birthday;
        }

        let data = {profile:this.profile};

        const self = this;

        this.panel.post('/v1/update/profile', data, (response) => {
            if (self.panel.okay(response)) {
              self.panel.setHasCompletedProfile(true);
              self.redirectUrl(redirectUrl);
            }
        });
    }

    update_match (redirectUrl) {
      redirectUrl = redirectUrl ? redirectUrl : '/profile/#match';
        for (let i in this.match) {
            if (this.match[i] != null) {
              this.match[i] = this.match[i].constructor === Array ? this.match[i].join(',') : this.match[i];
            }
        }

        let data = {match:this.match};

        const self = this;

        this.panel.post('/v1/update/match', data, (response) => {
            if (self.panel.okay(response)) {
              self.panel.setHasCompletedMatch(true);
              self.redirectUrl(redirectUrl);
            }
        });
    }

    get_checked_match (k, v) {
      return this.match[k] && this.match[k].indexOf(v+"") > -1;
    }

    push_match (k, v) {
      let match = [];
      if (this.match[k]) {
          match = this.match[k].split(',');
      }
      match.indexOf(v) > -1 && match.splice(match.indexOf(v),1) || match.push(v);
      this.match[k] = match.join(",");
    }

    hasCompletedMatch() {
      return parseInt(this.register.has_completed_match) > 0;
    }

    hasCompletedProfile() {
      return parseInt(this.register.has_completed_profile) > 0;
    }

    cancel () {
    }
}



// WEBPACK FOOTER //
// ./src/app/features/edit-settings/EditSettingsController.js